'use client';

export default function SearchFooter() {
    return (
        <div className="bg-slate-50/80 px-4 py-3 flex items-center justify-between border-t border-gray-100 backdrop-blur-md">
            <div className="flex items-center gap-4 text-[10px] text-gray-400 font-bold font-mono">
                <span className="flex items-center gap-1.5 opacity-60">
                    <kbd className="px-1.5 py-0.5 bg-white border border-gray-200 rounded-md shadow-sm">↵</kbd>
                    <span>SELECT / ASK</span>
                </span>
                <span className="flex items-center gap-1.5 opacity-60">
                    <kbd className="px-1.5 py-0.5 bg-white border border-gray-200 rounded-md shadow-sm">↑↓</kbd>
                    <span>MOVE</span>
                </span>
            </div>
            <div className="flex items-center gap-1 text-[10px] text-indigo-500 font-bold bg-indigo-50 px-2 py-0.5 rounded-lg">
                <span>Powered by InsuWiki Intelligence</span>
            </div>
        </div>
    );
}
